export interface Star {
  id: string;
  name: string;
  role: string;
  genre: string;
  heat: number;
  avatar: string;
  bio: string;
  news: string[];
  works: string[];
}

export const stars: Star[] = [
  {
    id: 'lin-zhi-yuan',
    name: '林知远',
    role: '演员',
    genre: '电影',
    heat: 9860,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20an%20elegant%20asian%20male%20actor%20in%20his%20thirties%20with%20short%20dark%20hair%20and%20calm%20expression%2C%20soft%20warm%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-lin&orientation=squarish',
    bio: '以细腻克制的表演风格著称，擅长塑造内心复杂、沉默隐忍的角色。凭借《长安夜行》中的大理寺少卿一角被更多观众熟知。',
    news: ['确认主演古装悬疑新作《长安夜行》续篇，明年春季开机', '受邀担任国际电影节青年单元评审', '谈表演：“沉默往往比台词更有力量”'],
    works: ['chang-an-ye-xing', 'wu-sheng-zheng-ci'],
  },
  {
    id: 'su-wan-qing',
    name: '苏晚晴',
    role: '演员',
    genre: '电影',
    heat: 9320,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20graceful%20asian%20woman%20in%20her%20late%20twenties%20with%20soft%20wavy%20hair%20and%20gentle%20confident%20gaze%2C%20warm%20natural%20lighting%2C%20neutral%20beige%20background%2C%20editorial%20quality&width=500&height=500&seq=star-su&orientation=squarish',
    bio: '从舞台剧走向银幕的演员，台词功底扎实，擅长在类型片中注入细腻的情感层次。近年活跃于古装与悬疑题材。',
    news: ['新片《长安夜行》口碑走高，角色讨论度持续登顶', '首度挑战幕后制片，筹备女性题材短片', '片场花絮曝光，敬业程度获导演点赞'],
    works: ['chang-an-ye-xing', 'di-qi-feng-you-jian'],
  },
  {
    id: 'shen-qing-he',
    name: '沈青禾',
    role: '演员',
    genre: '电影',
    heat: 8740,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20thoughtful%20asian%20man%20in%20his%20thirties%20with%20slightly%20long%20hair%20and%20serious%20eyes%2C%20clean%20soft%20lighting%2C%20muted%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-shen&orientation=squarish',
    bio: '以科幻与文艺双线发展的演员，表演冷静而富有张力。习惯为角色做大量案头功课，被剧组称为「最安静的创作者」。',
    news: ['《星海归途》定档，CG 挑战成为话题焦点', '分享太空题材拍摄经历：“孤独是最大的功课”', '确认出演独立文艺片《昨日之海》'],
    works: ['xing-hai-gui-tu', 'yesterday-zhi-hai'],
  },
  {
    id: 'bai-lu-ming',
    name: '白鹿鸣',
    role: '演员',
    genre: '电视剧',
    heat: 9120,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20sharp%20asian%20woman%20in%20her%20thirties%20with%20straight%20hair%20and%20intense%20focused%20expression%2C%20soft%20directional%20lighting%2C%20neutral%20grey%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-bai&orientation=squarish',
    bio: '实力与人气兼具的电视剧演员，擅长刑侦与悬疑类型。对角色逻辑要求严格，常与编剧一同打磨人物动机。',
    news: ['《迷城档案》收视领跑同期，成为年度话题剧', '加盟新剧《边城谜案》，挑战年代题材', '获年度最佳女主角提名'],
    works: ['mi-cheng-dang-an', 'bian-cheng-mi-an'],
  },
  {
    id: 'gu-qing-huan',
    name: '顾清欢',
    role: '演员',
    genre: '电视剧',
    heat: 8410,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20bright%20asian%20man%20in%20his%20late%20twenties%20with%20tidy%20short%20hair%20and%20warm%20friendly%20smile%2C%20soft%20even%20lighting%2C%20neutral%20warm%20background%2C%20editorial%20quality&width=500&height=500&seq=star-gu&orientation=squarish',
    bio: '从青春剧转型实力派的代表人物，角色跨度大。近年专注于刑侦与都市题材，被观众称为「最会演普通人的演员」。',
    news: ['《迷城档案》中搭档白鹿鸣，默契获好评', '参与都市新剧《人间烟火》拍摄', '跨界担任公益短片导演'],
    works: ['mi-cheng-dang-an', 'ren-jian-yan-huo'],
  },
  {
    id: 'jiang-huai-jin',
    name: '江怀瑾',
    role: '演员',
    genre: '电视剧',
    heat: 7960,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20dignified%20asian%20man%20in%20his%20forties%20with%20subtle%20grey%20at%20temples%20and%20composed%20expression%2C%20elegant%20warm%20lighting%2C%20neutral%20brown%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-jiang&orientation=squarish',
    bio: '资深演员，历史与正剧领域的常青树。气场沉稳，台词功底深厚，多次在群像大剧中担纲关键人物。',
    news: ['《王朝之影》中饰演权臣，演技被誉为教科书级别', '出版表演随笔集，分享三十年舞台心得', '获颁年度戏剧贡献荣誉'],
    works: ['wang-chao-zhi-ying', 'bian-cheng-mi-an'],
  },
  {
    id: 'su-huai-an',
    name: '苏怀安',
    role: '演员',
    genre: '电视剧',
    heat: 7730,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20kind%20asian%20man%20in%20his%20late%20thirties%20with%20short%20neat%20hair%20and%20gentle%20steady%20expression%2C%20clean%20soft%20lighting%2C%20neutral%20light%20grey%20background%2C%20editorial%20quality&width=500&height=500&seq=star-su2&orientation=squarish',
    bio: '以医疗与都市剧见长的演员，表演真挚自然。为贴近角色曾长期深入医院体验生活，被称为「肯下笨功夫」的演员。',
    news: ['《医者仁心》热播，角色引发医护群体共鸣', '参与现实题材新剧筹备', '分享体验生活细节：“角色长在生活里”'],
    works: ['yi-zhe-ren-xin', 'ren-jian-yan-huo'],
  },
  {
    id: 'song-tian-yao',
    name: '松田遥',
    role: '演员',
    genre: '电视剧',
    heat: 7180,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20quiet%20japanese%20woman%20in%20her%20thirties%20with%20soft%20straight%20hair%20and%20pensive%20expression%2C%20gentle%20muted%20lighting%2C%20neutral%20warm%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-matsuda&orientation=squarish',
    bio: '日本实力派演员，以细腻内敛的表演风格受到好评。擅长悬疑与都市情感题材，作品在亚洲市场均有稳定口碑。',
    news: ['《东京迷途》获好评，角色贯穿全剧悬念', '确认加盟亚洲合拍新片', '接受专访谈演员的「留白」'],
    works: ['dong-jing-mi-tu', 'summer-xie-zou-qu'],
  },
  {
    id: 'che-yun-hao',
    name: '车允浩',
    role: '演员',
    genre: '电视剧',
    heat: 8890,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20charming%20korean%20man%20in%20his%20late%20twenties%20with%20styled%20dark%20hair%20and%20warm%20confident%20smile%2C%20soft%20bright%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-che&orientation=squarish',
    bio: '人气与实力兼备的演员兼歌手，都市爱情题材的代表面孔。近年持续挑战更复杂的角色，逐步摆脱偶像标签。',
    news: ['《心跳频率》开播即登顶热门榜', '为剧集创作并演唱主题曲', '确认出演悬疑类型新剧，转型引期待'],
    works: ['xin-tiao-pin-lv'],
  },
  {
    id: 'chen-wang-shan',
    name: '陈望山',
    role: '导演',
    genre: '电影',
    heat: 8020,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20seasoned%20asian%20male%20film%20director%20in%20his%20fifties%20with%20grey%20hair%20and%20thoughtful%20expression%2C%20moody%20soft%20lighting%2C%20neutral%20dark%20cream%20background%2C%20editorial%20quality&width=500&height=500&seq=star-chen&orientation=squarish',
    bio: '以古装悬疑见长的电影导演，作品兼具商业张力与人文关怀。善于用光影与空间讲述人物命运，多次斩获业内奖项。',
    news: ['《长安夜行》票房与口碑双收', '宣布新作将挑战现实主义题材', '担任青年导演扶持计划导师'],
    works: ['chang-an-ye-xing'],
  },
];

export const starSortOptions = ['热度最高', '最新动态', '影视类型'];